module.exports = __webpack_public_path__ + "static/media/IMG_7982.a1e0cfab.JPG";